import {useEffect} from "react";

import {registerScrollContainerLockSuspend} from "@/src/modules/core/lib/scroll-container-lock-suspend";

const SCROLL_CONTAINER_SELECTOR = "[data-scroll-container]";

const LOCK_CLASSES = ["overflow-hidden", "flex", "flex-col"] as const;

/** Desktop dispatch desk: lock the app scroll column so panel flex slices get a real height. */
export function useDispatchDeskScrollLock() {
  useEffect(() => {
    const container = document.querySelector<HTMLElement>(SCROLL_CONTAINER_SELECTOR);
    if (!container) return;

    const media = window.matchMedia("(min-width: 1024px)");
    let overlaySuspendCount = 0;

    const syncLock = () => {
      if (media.matches && overlaySuspendCount === 0) {
        container.classList.add(...LOCK_CLASSES);
      } else {
        container.classList.remove(...LOCK_CLASSES);
      }
    };

    const onMediaChange = () => syncLock();

    registerScrollContainerLockSuspend(() => {
      overlaySuspendCount += 1;
      syncLock();
      return () => {
        overlaySuspendCount = Math.max(0, overlaySuspendCount - 1);
        syncLock();
      };
    });

    syncLock();
    media.addEventListener("change", onMediaChange);

    return () => {
      media.removeEventListener("change", onMediaChange);
      registerScrollContainerLockSuspend(null);
      container.classList.remove(...LOCK_CLASSES);
    };
  }, []);
}
